// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cleaner-payment-tx-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
}

.cleaner-payment-tx-wrap img{
    width: 36px;
    cursor: pointer;
}

.cleaner-payment-tx-wrap h3{
    font-size: 36px;
    color: #1A1919;
    font-weight: 500px;
    margin: 0px;
}

.cleaner-payment-tx-wrap h3 span{
    font-weight: 600;
}

.cleaner-payment-detail-header {
    margin-top: 34px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.cleaner-payment-detail-left h4 {
    font-size: 28px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
    margin-left: 54px;
    margin-top: 25px;
    margin-bottom: 20px;
}

.cleaner-payment-detail-left h4 span{
    font-weight: 600;
}

.cleaner-payment-detail-left p{
    font-size: 21px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
    margin-left: 54px;
}

.cleaner-payment-detail-left p span{
    /* color: #0F0FD5; */
    color:  #1E90FF;
}

.cleaner-payment-detail-left p span:hover{
    color: #0F0FD5 
}


.cleaner-payout-wrap {
    width: 700px;
    height: 65px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 22px;
    position: absolute;
    bottom: 50px;
    right: 180px;
}

.cleaner-payout-wrap h3 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.cleaner-payout-wrap p {
    font-size: 16px;
    color: #20CB00;
    font-weight: 600;
    margin: 0px;
}


.tranfer-history-dropdown-wrapper.table-responsive {
    height: calc(100vh - 450px);
    overflow: auto;
}

.transfer-history-header img.cleaner-payment-icon{
    width: 30px;
    margin-right: 4px;
}

.table-active-td{
    color:  #1E90FF !important;
}

.table-active-td:hover{
    color: #0F0FD5 !important;
}

.cleaner-payment-detail-right{
    text-align: center;
    margin-left: 0px;
}

.cleaner-payment-tx-wrap img:hover {
    scale: 0.9;
}

@media(max-width: 1024px){
    .cleaner-payment-detail-left h4 {
        font-size: 20px;
        margin-left: 54px;
        margin-top: 6px;
        margin-bottom: 10px;
    }

    .cleaner-payout-wrap {
        width: 480px;
        height: 60px;
        right: 40px;
        bottom: 70px;
    }

    .cleaner-payment-detail-header {
        justify-content: space-between;
        align-items: baseline;
        flex-direction: column;
    }

    .cleaner-payment-detail-right.filter-select-wraper.filter-select-wraper .select-box-wrapper {
        margin-left: 56px;
    }
}


@media(max-width: 767px){
    .cleaner-payment-tx-wrap {
        align-items: flex-start;
        flex-direction: column;
        gap: 14px;
    }  

    .cleaner-payment-detail-left p {
        margin-left: 0px;
    }

    .invoice-booking-client {
        margin-left: 0px;
        margin-top: 27px;
    }

    .invoice-booking-detail-bottom-wrapper {
        margin-left: 0px;
    }

    .transation-cart-detail-wrap {
        margin-left: 0px;
    }

    .transation-complete-image-wrap {
        margin-left: 0px;
    }


    .order-status-customer-review h3 {
        margin-bottom: 10px;
    }

    .cleaner-payment-detail-left h4 {
        font-size: 18px;
        margin-left: 0px;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .cleaner-payment-detail-right.filter-select-wraper.filter-select-wraper .select-box-wrapper {
        margin-left: 0px;
        text-align: left;
    }

    .cleaner-payout-wrap {
        width: 100%;
        height: 56px;
        right: 0px;
        bottom: 30px;
    }

}


@media (min-width: 1025px) and (max-width: 1599px) {
    .cleaner-payment-tx-wrap h3 {
      font-size: 22px;
    }
  
    .cleaner-payment-detail-left p {
      font-size: 18px;
    }
  
    .invoice-booking-client h3 {
      font-size: 20px;
    }
  
    .booking-client-detail p {
      font-size: 18px;
    }
  
    .invoice-booking-industry-wrap {
      margin-top: 40px;
    }

    .send-mail-btn p {
        font-size: 14px;
    }

    .invoice-status-wrapper h3 {
        font-size: 24px;
        padding-bottom: 4px;
    }

    .invoce-status-btn-wrap {
        width: 180px;
        height: 52px;
    }

    .invoce-status-btn-wrap p {
        font-size: 18px;
    }

    .transaction-status-btn-wrapper button {
        width: 180px;
        height: 52px;
        font-size: 18px;
    }

    .transaction-status-btn-wrapper {
        gap: 10px
    }

    .invoice-payout-wrap {
        width: 100%;
        height: 52px;
    }

    .booking-client-detail-wrap {
        gap: 40px
    }

    .cleaner-payment-detail-left h4 {
        font-size: 18px;
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .cleaner-payout-wrap {
        width: 600px;
        height: 65px;
        right: 80px;
    }

    .transfer-history-header img.cleaner-payment-icon {
        width: 26px;
        margin-right: 10px;
    }

  }



@media (min-width: 1025px) and (max-width: 1199px) {
    .cleaner-payment-tx-wrap h3 {
      font-size: 18px;
    }
  
    .cleaner-payment-detail-left p {
      font-size: 16px;
    }
  
    .invoice-booking-client h3 {
      font-size: 20px;
    }
  
    .booking-client-detail p {
        font-size: 16px;
    }
  
    .invoice-booking-industry-wrap {
      margin-top: 40px;
    }

    .booking-client-detail-wrap {
        gap: 20px
    }

    .send-mail-btn p {
        font-size: 14px;
    }

    .invoice-status-wrapper h3 {
        font-size: 22px;
        padding-bottom: 4px;
    }

    .invoce-status-btn-wrap {
        width: 160px;
        height: 48px;
    }

    .invoce-status-btn-wrap p {
        font-size: 16px;
    }

    .transaction-status-btn-wrapper button {
        width: 160px;
        height: 48px;
        font-size: 16px;
    }

    .transaction-status-btn-wrapper {
        gap: 10px
    }

    .invoice-payout-wrap {
        width: 100%;
        height: 52px;
    }

    .cleaner-payment-tx-wrap img {
        width: 30px;
    }

    .cleaner-payment-tx-wrap {
        gap: 6px;
    }

    .cleaner-payment-detail-left p {
        margin-left: 40px;
    }

    .invoice-booking-client {
        margin-left: 40px;
        margin-top: 30px;
    }

    .send-mail-btn {
        margin-top: 6px;
    }

    .invoice-booking-detail-bottom-wrapper {
        margin-left: 40px;
    }

    .invoice-booking-detail-bottom-left {
        width: 48%;
    }

    .invoice-booking-detail-bottom-right {
        width: 42%;
    }

    .invoice-address-right img {
        width: 22px;
    }

    p.right-border-line {
        border-right: none;
        padding-right: 0px;
    }

    .invoice-address-right p {
        font-size: 13px;
    }

    .invoice-address-left p {
        font-size: 13px;
    }

    .contact-person-detail h4 {
        font-size: 14px;
    }


    .invoice-booking-industry-wrap h4 {
        font-size: 14px;
    }

    .invoice-address-left h4 {
        font-size: 14px;
    }

    .invoice-address-right h4 {
        font-size: 14px;
    }

    .invoice-payout-wrap h3 {
        font-size: 14px;
    }

    .invoice-payout-wrap p {
        font-size: 14px;
    }

    .booking-cart-item-right {
        gap: 4px;
    }

    .booking-cart-items-wrap.tracking-cart-item-wrap {
        padding-right: 20px;
    }

    .transation-cart-status-wrap {
        padding-right: 20px;
    }

    .order-track-text-stat {
        font-size: 14px;
    }

    .msger-chat {
        flex: 1 1;
        overflow-y: auto;
        padding: 20px 10px
    }

    .cleaner-payment-detail-left h4 {
        margin-left: 40px;
        font-size: 16px;
    }

    .cleaner-payout-wrap {
        width: 600px;
        height: 65px;
        right: 80px;
        bottom: 20px;
    }

  }`, "",{"version":3,"sources":["webpack://./src/Dashboard/cleanerpayment/cleanerpayment.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI;AACJ;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,8BAA8B;QAC9B,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,YAAY;IAChB;;AAEJ;;;AAGA;IACI;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;EAEF;;;;AAIF;IACI;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;;EAEF","sourcesContent":[".cleaner-payment-tx-wrap {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.cleaner-payment-tx-wrap img{\n    width: 36px;\n    cursor: pointer;\n}\n\n.cleaner-payment-tx-wrap h3{\n    font-size: 36px;\n    color: #1A1919;\n    font-weight: 500px;\n    margin: 0px;\n}\n\n.cleaner-payment-tx-wrap h3 span{\n    font-weight: 600;\n}\n\n.cleaner-payment-detail-header {\n    margin-top: 34px;\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n.cleaner-payment-detail-left h4 {\n    font-size: 28px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n    margin-left: 54px;\n    margin-top: 25px;\n    margin-bottom: 20px;\n}\n\n.cleaner-payment-detail-left h4 span{\n    font-weight: 600;\n}\n\n.cleaner-payment-detail-left p{\n    font-size: 21px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n    margin-left: 54px;\n}\n\n.cleaner-payment-detail-left p span{\n    /* color: #0F0FD5; */\n    color:  #1E90FF;\n}\n\n.cleaner-payment-detail-left p span:hover{\n    color: #0F0FD5 \n}\n\n\n.cleaner-payout-wrap {\n    width: 700px;\n    height: 65px;\n    background: #F5F5F5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 22px;\n    position: absolute;\n    bottom: 50px;\n    right: 180px;\n}\n\n.cleaner-payout-wrap h3 {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.cleaner-payout-wrap p {\n    font-size: 16px;\n    color: #20CB00;\n    font-weight: 600;\n    margin: 0px;\n}\n\n\n.tranfer-history-dropdown-wrapper.table-responsive {\n    height: calc(100vh - 450px);\n    overflow: auto;\n}\n\n.transfer-history-header img.cleaner-payment-icon{\n    width: 30px;\n    margin-right: 4px;\n}\n\n.table-active-td{\n    color:  #1E90FF !important;\n}\n\n.table-active-td:hover{\n    color: #0F0FD5 !important;\n}\n\n.cleaner-payment-detail-right{\n    text-align: center;\n    margin-left: 0px;\n}\n\n.cleaner-payment-tx-wrap img:hover {\n    scale: 0.9;\n}\n\n@media(max-width: 1024px){\n    .cleaner-payment-detail-left h4 {\n        font-size: 20px;\n        margin-left: 54px;\n        margin-top: 6px;\n        margin-bottom: 10px;\n    }\n\n    .cleaner-payout-wrap {\n        width: 480px;\n        height: 60px;\n        right: 40px;\n        bottom: 70px;\n    }\n\n    .cleaner-payment-detail-header {\n        justify-content: space-between;\n        align-items: baseline;\n        flex-direction: column;\n    }\n\n    .cleaner-payment-detail-right.filter-select-wraper.filter-select-wraper .select-box-wrapper {\n        margin-left: 56px;\n    }\n}\n\n\n@media(max-width: 767px){\n    .cleaner-payment-tx-wrap {\n        align-items: flex-start;\n        flex-direction: column;\n        gap: 14px;\n    }  \n\n    .cleaner-payment-detail-left p {\n        margin-left: 0px;\n    }\n\n    .invoice-booking-client {\n        margin-left: 0px;\n        margin-top: 27px;\n    }\n\n    .invoice-booking-detail-bottom-wrapper {\n        margin-left: 0px;\n    }\n\n    .transation-cart-detail-wrap {\n        margin-left: 0px;\n    }\n\n    .transation-complete-image-wrap {\n        margin-left: 0px;\n    }\n\n\n    .order-status-customer-review h3 {\n        margin-bottom: 10px;\n    }\n\n    .cleaner-payment-detail-left h4 {\n        font-size: 18px;\n        margin-left: 0px;\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n    .cleaner-payment-detail-right.filter-select-wraper.filter-select-wraper .select-box-wrapper {\n        margin-left: 0px;\n        text-align: left;\n    }\n\n    .cleaner-payout-wrap {\n        width: 100%;\n        height: 56px;\n        right: 0px;\n        bottom: 30px;\n    }\n\n}\n\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n    .cleaner-payment-tx-wrap h3 {\n      font-size: 22px;\n    }\n  \n    .cleaner-payment-detail-left p {\n      font-size: 18px;\n    }\n  \n    .invoice-booking-client h3 {\n      font-size: 20px;\n    }\n  \n    .booking-client-detail p {\n      font-size: 18px;\n    }\n  \n    .invoice-booking-industry-wrap {\n      margin-top: 40px;\n    }\n\n    .send-mail-btn p {\n        font-size: 14px;\n    }\n\n    .invoice-status-wrapper h3 {\n        font-size: 24px;\n        padding-bottom: 4px;\n    }\n\n    .invoce-status-btn-wrap {\n        width: 180px;\n        height: 52px;\n    }\n\n    .invoce-status-btn-wrap p {\n        font-size: 18px;\n    }\n\n    .transaction-status-btn-wrapper button {\n        width: 180px;\n        height: 52px;\n        font-size: 18px;\n    }\n\n    .transaction-status-btn-wrapper {\n        gap: 10px\n    }\n\n    .invoice-payout-wrap {\n        width: 100%;\n        height: 52px;\n    }\n\n    .booking-client-detail-wrap {\n        gap: 40px\n    }\n\n    .cleaner-payment-detail-left h4 {\n        font-size: 18px;\n        margin-top: 12px;\n        margin-bottom: 12px;\n    }\n\n    .cleaner-payout-wrap {\n        width: 600px;\n        height: 65px;\n        right: 80px;\n    }\n\n    .transfer-history-header img.cleaner-payment-icon {\n        width: 26px;\n        margin-right: 10px;\n    }\n\n  }\n\n\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n    .cleaner-payment-tx-wrap h3 {\n      font-size: 18px;\n    }\n  \n    .cleaner-payment-detail-left p {\n      font-size: 16px;\n    }\n  \n    .invoice-booking-client h3 {\n      font-size: 20px;\n    }\n  \n    .booking-client-detail p {\n        font-size: 16px;\n    }\n  \n    .invoice-booking-industry-wrap {\n      margin-top: 40px;\n    }\n\n    .booking-client-detail-wrap {\n        gap: 20px\n    }\n\n    .send-mail-btn p {\n        font-size: 14px;\n    }\n\n    .invoice-status-wrapper h3 {\n        font-size: 22px;\n        padding-bottom: 4px;\n    }\n\n    .invoce-status-btn-wrap {\n        width: 160px;\n        height: 48px;\n    }\n\n    .invoce-status-btn-wrap p {\n        font-size: 16px;\n    }\n\n    .transaction-status-btn-wrapper button {\n        width: 160px;\n        height: 48px;\n        font-size: 16px;\n    }\n\n    .transaction-status-btn-wrapper {\n        gap: 10px\n    }\n\n    .invoice-payout-wrap {\n        width: 100%;\n        height: 52px;\n    }\n\n    .cleaner-payment-tx-wrap img {\n        width: 30px;\n    }\n\n    .cleaner-payment-tx-wrap {\n        gap: 6px;\n    }\n\n    .cleaner-payment-detail-left p {\n        margin-left: 40px;\n    }\n\n    .invoice-booking-client {\n        margin-left: 40px;\n        margin-top: 30px;\n    }\n\n    .send-mail-btn {\n        margin-top: 6px;\n    }\n\n    .invoice-booking-detail-bottom-wrapper {\n        margin-left: 40px;\n    }\n\n    .invoice-booking-detail-bottom-left {\n        width: 48%;\n    }\n\n    .invoice-booking-detail-bottom-right {\n        width: 42%;\n    }\n\n    .invoice-address-right img {\n        width: 22px;\n    }\n\n    p.right-border-line {\n        border-right: none;\n        padding-right: 0px;\n    }\n\n    .invoice-address-right p {\n        font-size: 13px;\n    }\n\n    .invoice-address-left p {\n        font-size: 13px;\n    }\n\n    .contact-person-detail h4 {\n        font-size: 14px;\n    }\n\n\n    .invoice-booking-industry-wrap h4 {\n        font-size: 14px;\n    }\n\n    .invoice-address-left h4 {\n        font-size: 14px;\n    }\n\n    .invoice-address-right h4 {\n        font-size: 14px;\n    }\n\n    .invoice-payout-wrap h3 {\n        font-size: 14px;\n    }\n\n    .invoice-payout-wrap p {\n        font-size: 14px;\n    }\n\n    .booking-cart-item-right {\n        gap: 4px;\n    }\n\n    .booking-cart-items-wrap.tracking-cart-item-wrap {\n        padding-right: 20px;\n    }\n\n    .transation-cart-status-wrap {\n        padding-right: 20px;\n    }\n\n    .order-track-text-stat {\n        font-size: 14px;\n    }\n\n    .msger-chat {\n        flex: 1 1;\n        overflow-y: auto;\n        padding: 20px 10px\n    }\n\n    .cleaner-payment-detail-left h4 {\n        margin-left: 40px;\n        font-size: 16px;\n    }\n\n    .cleaner-payout-wrap {\n        width: 600px;\n        height: 65px;\n        right: 80px;\n        bottom: 20px;\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
